(() => {
  if (window.CMALeadFlow) { window.CMALeadFlow.start(); return; }
  const publish = (name, data) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      Promise.resolve(window.Shopify.analytics.publish('cma:' + name, data)).catch(() => {});
      return true;
    } catch { return false; }
  };
  function start() {
    const url = new URL(location.href);
    const campaign = {};
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
      const value = url.searchParams.get(key);
      if (value) campaign[key] = value.slice(0, 240);
    }
    let prior = {};
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        prior = JSON.parse(sessionStorage.getItem('cma_campaign') || '{}');
        if (Object.keys(campaign).length) sessionStorage.setItem('cma_campaign', JSON.stringify(campaign));
      }
    } catch {}
    document.querySelectorAll('[data-cma-lead-form]').forEach(form => {
      if (form.dataset.cmaLeadReady) return;
      form.dataset.cmaLeadReady = 'true';
      const kind = form.dataset.cmaLeadForm;
      const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'contact[' + name + ']'; input.value = value; form.append(input);
      };
      add('Source page', url.origin + url.pathname);
      let referrer = '';
      try { referrer = document.referrer ? new URL(document.referrer).hostname : ''; } catch {}
      if (referrer) add('Referrer host', referrer);
      for (const [key, value] of Object.entries(Object.keys(campaign).length ? campaign : prior)) add(key, value);
      const context = () => ({form: kind, page: url.pathname, offer: form.querySelector('[data-cma-select="offer"] option:checked')?.dataset.handle || url.searchParams.get('offer') || ''});
      let started = false;
      form.addEventListener('input', () => { if (!started) started = publish('inquiry_started', context()); });
      if (form.querySelector('[data-cma-success]')) publish(kind === 'design_interest' ? 'design_interest_received' : 'inquiry_received', context());
      form.addEventListener('submit', () => publish(kind === 'design_interest' ? 'design_interest_submitted' : 'inquiry_submitted', context()));
    });
  }
  window.CMALeadFlow = {start};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
